import LocalStorageUtils from "utils/localStorage";

class FavoriteResourceCalculator {

	_resourceKey = null;
	_defaultStore = null

	constructor(resourceKey, defaultStore = {}) {
		if (typeof resourceKey !== "string" || resourceKey === "") {
			throw new Error("The 'resourceKey' is required must be string")
		}
		this._resourceKey = resourceKey;
		this._defaultStore = defaultStore;
	}

	get resource() {
		const resource = LocalStorageUtils.get(this._resourceKey) ?? this._defaultStore;
		return resource;
	}

	increment(resourcePart) {
		let resource = this.resource;
		const resourcePartValue = resource[resourcePart] ?? 0;
		const newResourcePartValue = resourcePartValue + 1;
		resource[resourcePart] = newResourcePartValue;
		if (newResourcePartValue === Infinity) {
			resource = this._reassignment(resource);
		}
		LocalStorageUtils.set(this._resourceKey, resource);
	}

	decrement(resourcePart) {
		let resource = this.resource;
		const resourcePartValue = resource[resourcePart] ?? 0;
		const newResourcePartValue = resourcePartValue - 1;
		resource[resourcePart] = newResourcePartValue;
		if (newResourcePartValue === 0) {
			resource = this._reassignment(resource);
		}
		LocalStorageUtils.set(this._resourceKey, resource);
	}

	_reassignment(resource) {
		const resourceEntries = Object.entries(resource);
		resourceEntries.sort((nextResourcePart, prevResourcePart) => {
			const nextResourcePartCount = nextResourcePart[1];
			const prevResourcePartCount = prevResourcePart[1];
			return prevResourcePartCount - nextResourcePartCount;
		});
		const newResourceEntries = resourceEntries.map((resourcePart, index, arr) => {
			if (resourcePart[1] > 0) {
				resourcePart[1] = arr.length - index;
			}
			return resourcePart;
		});
		return Object.fromEntries(newResourceEntries);
	}
}

export default FavoriteResourceCalculator;